export const FormFieldKeys = {
	COLLECTION_NAME: 'collectionName',
	PROJECTS: 'projects',
	FILTERS: 'filters',
} as const;

export const IDEAS_COUNT_LIMIT = 2000;
export const IDEAS_COUNT_LIMIT_OLD = 5000;
